import { render } from "./ModalDialog.vue?vue&type=template&id=02bb8fc2"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"

import "./ModalDialog.vue?vue&type=style&index=0&id=02bb8fc2&lang=css"

import exportComponent from "../../../momsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__